const Frequency = {
  Instant: 'Instant',
  Daily: 'Daily',
  Weekly: 'Weekly',
} as const;

export const CandidateOppFeedAlertsConst = {
  Frequency,
} as const;
